export const doc_data = [
    {
        id: 1,
        name: 'Maxwell David',
        specialization: 'surgeon'
    },
    {
        id: 2,
        name: 'Ana miller',
        specialization: 'dentist'
    },
    {
        id: 3,
        name: 'fredrick jordon',
        specialization: 'opthamologist'
    },
    {
        id: 4,
        name: 'milley morgan',
        specialization: 'nurse'
    }
];

export const Appointmentmonths = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];